import { AuthService } from './../../shared/models/auth.service';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';
import { JQueryHelperService } from '../../shared/models/jquery-helper.service';
import { SharedVehicleGroupAdminInvitationModel } from '../../admin-invite-popup/models/admin-to-invite.model';


@Injectable()
export class AdminOfSharedVehicleGroupService {
    constructor(private authService: AuthService, private http: Http) { }
    
    private JQueryHelper: JQueryHelperService = new JQueryHelperService();

    public GetAdminOfSharedVehicleGroupList(svgHashID: string, input?: DataListModel): Observable<IAPIResponse> {
        let getSVGAdminUrl = WeGoConfig.API_GET_ADMIN_OF_SVG_LIST;
        let queryString = this.authService.HandleAPIListInput(input);
        if (queryString) {
            getSVGAdminUrl = getSVGAdminUrl + "?" + queryString + "&svgHashID=" + svgHashID;
        }
        else {
            getSVGAdminUrl = getSVGAdminUrl + "?svgHashID=" + svgHashID;
        }
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        return this.http.get(getSVGAdminUrl, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public ExportAdminOfsharedVehicleGroupList(svgHashId: string, input?: DataListModel): any {
        input.currentPage = 0;
        let queryString = this.authService.HandleAPIListInput(input);
        let getCompanyAdminUrl = WeGoConfig.API_EXPORT_ADMIN_OF_SVG_LIST + "?" + queryString + "&sharedVehicleGroupHashId=" + svgHashId;
        let headers = this.authService.GetHeader('text/csv');
        let options = new RequestOptions({ headers: headers });
        return this.http.get(getCompanyAdminUrl, options);
    }

    public DeleteAdminOfSharedVehicleGroup(svgHashId: string, selectedAdminOfSVGList: string[]): Observable<IAPIResponse> {
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        let urlDeleteAdminOfSVG = WeGoConfig.API_POST_DELETE_ADMIN_OF_SVG + "?sharedVehicleGroupHashId=" + svgHashId;

        return this.http.post(urlDeleteAdminOfSVG, selectedAdminOfSVGList, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public GetAllRoleAvailability(input?: DataListModel, svgHashId?: string): Observable<IAPIResponse> {
        let getRoleAvailabilityListUrl = WeGoConfig.API_GET_SVG_ROLEAVAILABILITY_LIST + "?svgHashId=" + svgHashId;
        let queryString = this.authService.HandleAPIListInput(input);
        if (queryString) {
            getRoleAvailabilityListUrl = getRoleAvailabilityListUrl + "&" + queryString;
        }
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        return this.http.get(getRoleAvailabilityListUrl, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public DeleteAdminOfSharedVehicleGroupRole(svgHashId: string, personHashId: string, roleHashId: string): Observable<IAPIResponse> {
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        let urlDeleteAdminOfSVG = WeGoConfig.API_POST_DELETE_ADMIN_OF_SVG_ROLE + "?sharedVehicleGroupHashId=" + svgHashId + "&personHashId=" + personHashId + "&roleHashId=" + roleHashId;

        return this.http.get(urlDeleteAdminOfSVG, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public AddAdminOfSharedVehicleGroupRole(svgHashId: string, personHashId: string, roleHashId: string): Observable<IAPIResponse> {
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        let urlAddAdminOfSVG = WeGoConfig.API_POST_ADD_ADMIN_OF_SVG_ROLE + "?sharedVehicleGroupHashId=" + svgHashId + "&personHashId=" + personHashId + "&roleHashId=" + roleHashId;;

        return this.http.get(urlAddAdminOfSVG, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }
    
    public GetPersonListToInvite(svgHashID: string, emailAddress: string): Observable<IAPIResponse> {
        let getSVGAdminUrl = WeGoConfig.API_GET_SVG_PERSON_TO_INVITE_LIST

        getSVGAdminUrl = getSVGAdminUrl + "?sharedVehicleGroupHashID=" + svgHashID + "&emailAddress=" + emailAddress;

        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        return this.http.get(getSVGAdminUrl, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public InviteAdminOfsharedVehicleGroup(svgAdminInvitationModel:SharedVehicleGroupAdminInvitationModel): Observable<IAPIResponse> {
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        let urlInviteAdminOfSharedVehicleGroup = WeGoConfig.API_POST_INVITE_ADMIN_OF_SVG ;      

        return this.http.post(urlInviteAdminOfSharedVehicleGroup, svgAdminInvitationModel, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }
    
    // public InviteAdminOfCustomer(customerAdminInvitationModel:CustomerAdminInvitationModel): Observable<IAPIResponse> {
    //     let headers = this.authService.GetHeader();
    //     let options = new RequestOptions({ headers: headers });
    //     let urlInviteAdminOfCustomer = WeGoConfig.API_POST_INVITE_ADMIN_OF_CUSTOMER ;      

    //     return this.http.post(urlInviteAdminOfCustomer, customerAdminInvitationModel, options)
    //         .map(this.authService.HandleAPIResponse)
    //         .catch(this.authService.HandleAPIError);
    // }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin-of-sharedvehiclegroup/models/admin-of-SharedVehicleGroup.service.ts